import Vue from 'vue';
// import RowLimit from './components/RowLimit.vue';
// import SearchInput from './components/SearchInput.vue';
// import Dropdown from './components/Dropdown.vue';
// import ActiveSvg from './components/ActiveSvg.vue';
// import PopOver from './components/PopOver.vue';
// import ProductAutocomplete from './components/ProductAutocomplete.vue';
// import OnClickOutside from './components/OnClickOutside.vue';
// import Modal from './components/modal/Modal.vue';
// import TableFilterButton from './components/TableFilterButton.vue';
// import WarehouseSelect from './components/WarehouseSelect.vue';
// import Toggler from './components/Toggler.vue';
// import TablePagination from './components/TablePagination.vue';
// import PageHeaderBar from './components/layout/PageHeaderBar.vue';
// import CheckBox from './components/CheckBox.vue';
// import FancyCheckBox from './components/CheckBox.vue';
// import Me from './components/Me.vue';
// import QuantityInput from './components/QuantityInput.vue';
// import BarcodeFabButton from './components/BarcodeFabButton.vue';
// import Price from './components/Price.vue';
// import TopHeader from './components/common/TopHeader.vue';
// import DatePicker from './components/DatePicker.vue';
// import Box from './components/common/Box.vue';
// import FormInput from './components/common/FormInput.vue';
// import CopyText from './components/CopyText.vue';
// import ButtonBase from './components/ButtonBase.vue';

// Register as global
Vue.component('ButtonBase', () => import('./components/ButtonBase.vue'));
Vue.component('Box', () => import('./components/common/Box.vue'));
Vue.component('DatePicker', () => import('./components/DatePicker.vue'));
Vue.component('TopHeader', () => import('./components/common/TopHeader.vue'));
Vue.component('CheckBox', () => import('./components/CheckBox.vue'));
Vue.component('FancyCheckBox', () => import('./components/CheckBox.vue'));
Vue.component('RowLimit', () => import('./components/RowLimit.vue'));
Vue.component('SearchInput', () => import('./components/SearchInput.vue'));
Vue.component('Dropdown', () => import('./components/Dropdown.vue'));
Vue.component('ActiveSvg', () => import('./components/ActiveSvg.vue'));
Vue.component('PopOver', () => import('./components/PopOver.vue'));
Vue.component('ProductAutocomplete', () =>
  import('./components/ProductAutocomplete.vue')
);
Vue.component('OnClickOutside', () =>
  import('./components/OnClickOutside.vue')
);
Vue.component('Modal', () => import('./components/modal/Modal.vue'));
Vue.component('TableFilterButton', () =>
  import('./components/TableFilterButton.vue')
);
Vue.component('WarehouseSelect', () =>
  import('./components/WarehouseSelect.vue')
);
Vue.component('Toggler', () => import('./components/Toggler.vue'));
Vue.component('TablePagination', () =>
  import('./components/TablePagination.vue')
);
Vue.component('PageHeaderBar', () =>
  import('./components/layout/PageHeaderBar.vue')
);
Vue.component('Me', () => import('./components/Me.vue'));
Vue.component('QuantityInput', () => import('./components/QuantityInput.vue'));
Vue.component('BarcodeFabButton', () =>
  import('./components/BarcodeFabButton.vue')
);
Vue.component('Price', () => import('./components/Price.vue'));
Vue.component('FormInput', () => import('./components/common/FormInput.vue'));
Vue.component('CopyText', () => import('./components/CopyText.vue'));
Vue.component('PaginationNav', () =>
  import('./components/pagination/PaginationNav.vue')
);



// WEBPACK FOOTER //
// ./src/registerComponents.js